import { action, observable } from 'mobx';
import enUS from 'antd/lib/locale/en_US';
import zhHK from 'antd/lib/locale/zh_HK';
import zhTW from 'antd/lib/locale/zh_TW';
import thTH from 'antd/lib/locale/th_TH';
import { Locale } from 'antd/lib/locale-provider';
import 'moment/locale/zh-hk';
import 'moment/locale/zh-tw';
import 'moment/locale/th';
import { ELanguage } from '@/interfaces/common';

class Context {
  @observable locale: Locale = enUS;

  @action
  updateLocale = (lang: ELanguage) => {
    if (lang === ELanguage.ZH_HANT) {
      this.locale = zhHK;
    } else if (lang === ELanguage.TH) {
      this.locale = thTH;
    } else if (lang === ELanguage.TW) {
      this.locale = zhTW;
    } else {
      this.locale = enUS;
    }
  };
}

export default new Context();
